import { render, staticRenderFns } from "./ProjectPluginItem.vue?vue&type=template&id=9b84856a&scoped=true&"
import script from "./ProjectPluginItem.vue?vue&type=script&lang=js&"
export * from "./ProjectPluginItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPluginItem.vue?vue&type=style&index=0&id=9b84856a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b84856a",
  null
  
)

export default component.exports